/* FURVIA theme — UI + native cart logic */
(function () {
  'use strict';

  window.Furvia = window.Furvia || { color: 'Pink' };

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function fetchCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function renderDrawer(cart) {
    var drawer = document.querySelector('.fv-drawer');
    if (!drawer) return;
    var count = drawer.querySelector('[data-fv-cart-count]');
    var body = drawer.querySelector('[data-fv-cart-body]');
    var foot = drawer.querySelector('[data-fv-cart-foot]');
    if (count) count.textContent = cart.item_count;
    var badge = document.querySelector('.fv-cartcount');
    if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count ? 'flex' : 'none'; }

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="fv-drawer__empty"><p>Your cart is empty.</p><button class="fv-btn fv-btn--outline" data-fv-scroll="fv-shop" data-fv-close-cart>Shop FurLift</button></div>';
      foot.style.display = 'none';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      return '<div class="fv-line" data-key="' + item.key + '">' +
        '<div class="fv-line__img">' + (item.image ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_200x$1') + '" alt="' + (item.title || '') + '">' : '') + '</div>' +
        '<div class="fv-line__info">' +
          '<div class="fv-line__title"><div><div>' + item.product_title + '</div>' +
          (item.variant_title ? '<div class="fv-line__variant">' + item.variant_title + '</div>' : '') +
          '</div><div>' + money(item.final_line_price) + '</div></div>' +
          '<div class="fv-line__controls">' +
            '<div class="fv-qty"><button data-fv-qty="-1" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-fv-qty="1" aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button></div>' +
            '<button data-fv-remove aria-label="Remove item" style="padding:8px;color:var(--smoke)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="14" height="14"><path d="M3 6h18M8 6V4h8v2m1 0v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V6"/></svg></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    foot.style.display = '';
    var sub = foot.querySelector('[data-fv-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);

    body.querySelectorAll('[data-fv-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.closest('.fv-line').dataset.key;
        var qty = parseInt(btn.closest('.fv-qty').querySelector('span').textContent, 10) + parseInt(btn.dataset.fvQty, 10);
        changeLine(key, Math.max(0, qty));
      });
    });
    body.querySelectorAll('[data-fv-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(btn.closest('.fv-line').dataset.key, 0); });
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  }

  window.Furvia.openCart = function () {
    var drawer = document.querySelector('.fv-drawer');
    var bg = document.querySelector('.fv-drawer-bg');
    if (drawer) drawer.classList.add('fv-drawer--on');
    if (bg) bg.classList.add('fv-drawer-bg--on');
  };

  window.Furvia.closeCart = function () {
    var drawer = document.querySelector('.fv-drawer');
    var bg = document.querySelector('.fv-drawer-bg');
    if (drawer) drawer.classList.remove('fv-drawer--on');
    if (bg) bg.classList.remove('fv-drawer-bg--on');
  };

  window.Furvia.addToCart = function (variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetchCart();
    }).then(function (cart) {
      renderDrawer(cart);
      window.Furvia.openCart();
    }).catch(function () {
      window.location.href = '/cart';
    });
  };

  window.Furvia.buyNow = function (variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function () { window.location.href = '/checkout'; });
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('fv-loaded');

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.Lenis) {
      var lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      window.__lenis = lenis;
      (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(0);
    }

    var nav = document.querySelector('.fv-nav');
    function onScroll() { if (nav) nav.classList.toggle('fv-nav--scrolled', window.scrollY > 40); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    document.querySelectorAll('[data-fv-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.getAttribute('data-fv-scroll'));
        if (!target) return;
        e.preventDefault();
        if (a.hasAttribute('data-fv-close-cart')) window.Furvia.closeCart();
        var menu = document.querySelector('.fv-mobilemenu');
        if (menu) menu.classList.remove('fv-mobilemenu--open');
        if (window.__lenis) window.__lenis.scrollTo(target, { duration: 1.4 });
        else target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    var burger = document.querySelector('.fv-burger');
    var menu = document.querySelector('.fv-mobilemenu');
    if (burger && menu) burger.addEventListener('click', function () { menu.classList.add('fv-mobilemenu--open'); });
    if (menu) {
      var close = menu.querySelector('[data-fv-menu-close]');
      if (close) close.addEventListener('click', function () { menu.classList.remove('fv-mobilemenu--open'); });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('fv-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.fv-reveal').forEach(function (el) { io.observe(el); });

    document.querySelectorAll('.fv-ba').forEach(function (ba) {
      var input = ba.querySelector('input[type=range]');
      var after = ba.querySelector('.fv-ba__after');
      var line = ba.querySelector('.fv-ba__line');
      var handle = ba.querySelector('.fv-ba__handle');
      if (!input) return;
      input.addEventListener('input', function () {
        var p = input.value + '%';
        if (after) after.style.clipPath = 'inset(0 0 0 ' + p + ')';
        if (line) line.style.left = p;
        if (handle) handle.style.left = p;
      });
    });

    document.querySelectorAll('[data-fv-finish]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.Furvia.color = btn.getAttribute('data-fv-finish');
        document.querySelectorAll('[data-fv-finish]').forEach(function (b) {
          b.classList.toggle('fv-swatch--active', b === btn);
        });
        var nameEls = document.querySelectorAll('[data-fv-finish-name]');
        nameEls.forEach(function (el) { el.textContent = btn.getAttribute('data-fv-finish-label'); });
        var radio = document.querySelector('.fv-purchase input[data-fv-variant-color="' + window.Furvia.color.toLowerCase() + '"]');
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change')); }
        var cta = document.querySelector('[data-fv-finish-price]');
        if (cta) cta.textContent = btn.getAttribute('data-fv-finish-price') || '';
      });
    });

    var form = document.querySelector('.fv-purchase form');
    if (form) {
      var qtyEl = form.querySelector('[data-fv-qty-display]');
      var qtyInput = form.querySelector('input[name=quantity]');
      form.querySelectorAll('[data-fv-qty-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var q = Math.min(10, Math.max(1, parseInt(qtyInput.value, 10) + parseInt(btn.getAttribute('data-fv-qty-btn'), 10)));
          qtyInput.value = q;
          if (qtyEl) qtyEl.textContent = q;
        });
      });
      form.querySelectorAll('input[name=id]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var c = radio.getAttribute('data-fv-variant-color');
          if (c) {
            window.Furvia.color = c.charAt(0).toUpperCase() + c.slice(1);
            document.querySelectorAll('[data-fv-finish]').forEach(function (b) {
              b.classList.toggle('fv-swatch--active', b.getAttribute('data-fv-finish').toLowerCase() === c);
            });
          }
        });
      });
      var addBtn = form.querySelector('[data-fv-add]');
      if (addBtn) addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = form.querySelector('input[name=id]:checked');
        if (id) window.Furvia.addToCart(id.value, parseInt(qtyInput.value, 10));
      });
      var buyBtn = form.querySelector('[data-fv-buy]');
      if (buyBtn) buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = form.querySelector('input[name=id]:checked');
        if (id) window.Furvia.buyNow(id.value, parseInt(qtyInput.value, 10));
      });
    }

    var purchase = document.getElementById('fv-shop');
    var sticky = document.querySelector('.fv-stickybar');
    if (purchase && sticky) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('fv-stickybar--on', en.isIntersecting); });
      }, { threshold: 0.1 });
      io2.observe(purchase);
    }

    var cartBtn = document.querySelector('[data-fv-cart-open]');
    if (cartBtn) cartBtn.addEventListener('click', function () {
      fetchCart().then(renderDrawer);
      window.Furvia.openCart();
    });
    document.querySelectorAll('[data-fv-cart-close], .fv-drawer-bg').forEach(function (el) {
      el.addEventListener('click', window.Furvia.closeCart);
    });

    // story scenes
    document.querySelectorAll('.fv-story').forEach(function (section) {
      var scenes = section.querySelectorAll('.fv-scene');
      var ranges = [[0.01, 0.15], [0.16, 0.3], [0.31, 0.45], [0.47, 0.61], [0.63, 0.77], [0.8, 1.01]];
      var demo = section.querySelector('.fv-demo__after');
      function onScrollStory() {
        var r = section.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = Math.min(1, Math.max(0, -r.top / Math.max(1, total)));
        scenes.forEach(function (sc, i) {
          var on = p >= ranges[i][0] && p <= ranges[i][1];
          sc.classList.toggle('fv-scene--on', on);
        });
        if (demo) {
          var wipe = Math.min(1, Math.max(0, (p - 0.5) / 0.1));
          demo.style.clipPath = 'inset(0 ' + (100 - wipe * 100) + '% 0 0)';
        }
        if (window.Furvia3D) window.Furvia3D.storyProgress = p;
      }
      window.addEventListener('scroll', onScrollStory, { passive: true });
      onScrollStory();
    });
  });
})();
